<template>
  <v-container class="pa-0 ma-0">
    <!-- title -->
    <v-container class="pa-0 ma-0 mb-4 d-flex justify-space-between align-center rtl">
      <v-card-text class="pa-0 ma-0 text-body-1 font-weight-bold">
        {{ $t("QuickAccess") }}
      </v-card-text>
      <v-icon color="#F59E0B">mdi-flash</v-icon>
    </v-container>

    <!-- cards -->
    <v-row class="ma-0 pa-0" dense>
      <v-col v-for="(item, index) in items" :key="index" cols="3" sm="3" md="2" lg="">
        <v-container
          class="quick-card ma-0 pa-3 d-flex flex-column align-center justify-center gap-1"
        >
          <!-- icon -->
          <v-container
            class="pa-0 ma-0 icon-wrapper"
            :style="{ backgroundColor: getbackgroundColor(item.title) }"
          >
            <my-icon
              :name="getIconName(item.title).name"
              :width="18"
              :height="18"
              :stroke="getIconName(item.title).color"
              :fill="getIconName(item.title).color"
            />
          </v-container>
          <!-- title -->
          <v-card-text class="pa-0 ma-0 text-body-2 text-center">
            {{ item.title }}
          </v-card-text>
          <!-- value -->
          <v-card-text class="pa-0 ma-0 text-body-2">
            {{ item.value }}
          </v-card-text>

          <!-- percent -->
          <v-container class="pa-0 ma-0 d-flex align-center justify-center">
            <v-icon size="14" :color="getPercentColor(item.trend)" class="ml-1">
              {{ getPercentIcon(item.trend) }}
            </v-icon>
            <v-card-text
              class="pa-0 ma-0"
              :style="{ color: getPercentColor(item.trend) }"
            >
              {{ item.percent }}
            </v-card-text>
            <v-card-text class="pa-0 ma-0" :style="{ color: getPercentColor(item.trend) }"
              >%
            </v-card-text>
          </v-container>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MyIcon from "@/views/dashboard/components/general/icon/MyIcon.vue";

export default {
  name: "DashboardQuickAccess",
  components: { MyIcon },
  props: {
    purchaseData: {
      type: [Number, String, Object],
      required: true,
    },
    sellData: {
      type: [Number, String, Object],
      required: true,
    },
    warehouseData: {
      type: [Array, Object],
      required: true,
    },
    crmData: {
      type: [Array, Object],
      required: true,
    },
    costData: {
      type: [Array, Object],
      required: true,
    },
    taxData: {
      type: [Array, Object],
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    items() {
      return [
        {
          title: this.$t("sell"),
          value: this.formatNumber(this.sellData?.current ?? 0),
          percent: this.sellData?.diffPercent ?? 0,
          trend: this.sellData?.trend ?? "none",
        },
        {
          title: this.$t("buy"),
          value: this.formatNumber(this.purchaseData?.current ?? 0),
          percent: this.purchaseData?.diffPercent ?? 0,
          trend: this.purchaseData?.trend ?? "none",
        },
        {
          title: this.$t("entrepot"),
          value: this.formatNumber(this.warehouseData?.current?.total_balance_value ?? 0),
          percent: this.warehouseData?.diffPercent?.total_balance_count ?? 0,
          trend: this.warehouseData?.trend?.total_balance_count ?? "none",
        },
        {
          title: this.$t("costs"),
          value: this.formatNumber(this.costData?.current ?? 0),
          percent: this.costData?.diffPercent ?? 0,
          trend: this.costData?.trend ?? "none",
        },
        {
          title: this.$t("tax"),
          value: this.formatNumber(this.taxData?.current ?? 0),
          percent: this.taxData?.diffPercent ?? 0,
          trend: this.taxData?.trend ?? "none",
        },
        // {
        //   title: "تنخواه",
        //   value: "0",
        //   percent: 0,
        //   trend: 0,
        // },
        // {
        //   title: "خزانه",
        //   value: "0",
        //   percent: 0,
        //   trend: 0,
        // },
        {
          title: "CRM",
          value: this.formatNumber(this.crmData?.current ?? 0),
          percent: this.crmData?.diffPercent ?? 0,
          trend: this.crmData?.trend ?? "none",
        },
        // {
        //   title: "تولید",
        //   value: "0",
        //   percent: 0,
        //   trend: 0,
        // },
      ];
    },
  },
  methods: {
    formatNumber(value, decimals = 1) {
      if (value === null || value === undefined) return "0";

      const num = Number(value);

      if (Math.abs(num) >= 1_000_000_000) {
        return " B" + (num / 1_000_000_000).toFixed(decimals).replace(/\.0$/, "");
      }

      if (Math.abs(num) >= 1_000_000) {
        return " M" + (num / 1_000_000).toFixed(decimals).replace(/\.0$/, "");
      }

      if (Math.abs(num) >= 1_000) {
        return " K" + (num / 1_000).toFixed(decimals).replace(/\.0$/, "");
      }

      return num.toLocaleString();
    },
    getIconName(title) {
      const map = {
        [this.$t("sell")]: {
          name: "shopping-cart",
          color: "#fff",
        },
        [this.$t("buy")]: {
          name: "bag-shop",
          color: "#fff",
        },
        [this.$t("entrepot")]: {
          name: "cube-icon",
          color: "#fff",
        },
        [this.$t("costs")]: {
          name: "document-icon",
          color: "#fff",
        },
        [this.$t("tax")]: {
          name: "posCard-icon",
          color: "#fff",
        },
        CRM: {
          name: "users-icon",
          color: "#fff",
        },
      };
      return (
        map[title] || {
          name: "billan",
          color: "#fff",
        }
      );
    },

    getbackgroundColor(title) {
      if (title === this.$t("sell")) return "#155DFC";
      if (title === this.$t("buy")) return "#00A63E";
      if (title === this.$t("entrepot")) return "#F54900";
      if (title === this.$t("costs")) return "#E7000B";
      if (title === this.$t("tax")) return "#9810FA";
      if (title === "CRM") return "#E60076";
    },
    getPercentColor(trend) {
      if (trend != null && trend == "increase") {
        return "#00A63E";
      }
      if (trend != null && trend == "decrease") {
        return "#E7000B";
      }
      if (trend != null && trend == "none") {
        return "#a7a4a4ff";
      }
    },
    getPercentIcon(trend) {
      if (trend != null && trend == "increase") {
        return "mdi-arrow-top-right";
      }
      if (trend != null && trend == "decrease") {
        return "mdi-arrow-bottom-right";
      }
      if (trend != null && trend == "none") {
        return "";
      }
    },
  },
};
</script>
<style scoped>
.quick-card {
  border-radius: 4px;
  border: 1px solid #e5e7eb;
  background: #ffffff;
  width: auto;
  height: 140px;
}

.icon-wrapper {
  width: 48px;
  height: 48px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
